import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'catalogo',
})
export class CatalogoPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if(filter['id_familia'] > 0){

      items = items.filter(function(item) {

        return item.id_familia == filter['id_familia'];

      });

    }

    if(filter['habituales'] == 1){

      items = items.filter(function(item) {

        return item.habitual == 1;

      });
    }

    return items;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/catalogo/catalogo.ts